/* eslint-disable no-console */
import React from 'react'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from 'store'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import './i18n'
// eslint-disable-next-line import/no-extraneous-dependencies
import TagManager from 'react-gtm-module'

TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID ?? '' })

const container = document.getElementById('app')!

const root = createRoot(container)

root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
